/**
 * Convert a Shopify price to a string
 * @param {Number} amountInPennies
 * @return {String}
 */
export function asMoneyString(amountInPennies) {
	// Shopify stores values as number of pennies;
	// Intl.NumberFormat thinks we are passing number of dollars.
	const amountInDollars = amountInPennies / 100

	// TODO: Change to current locale
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})
	return formatter.format(amountInDollars)
}